import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import Page from '../../components/Page';
import { SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const ManageAds = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [totalcount, setTotalcount] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { sendNetworkRequest } = React.useContext(NetworkContext);

  async function fetchallads(searchtext = '') {
    let bodycontent = {
      page: page * rowsPerPage,
      searchtext : searchtext,
      limit: rowsPerPage
    }
    let ads = await sendNetworkRequest('/admin/getads', {}, bodycontent, false)

    setTotalcount(ads.module.length)
    setOrders(ads.module)
  }
  function onPageChange(page) {
    setPage(page)
  }
  function onPageLimit(limit) {
    setRowsPerPage(limit)
  }
  useEffect(() => {
    fetchallads()

  }, [page, rowsPerPage]);
  function onSearch(searchtext)
  {
    fetchallads(searchtext)
  }
  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
      <SearchBar   onSearch={onSearch} />
      <Results
        className={classes.results}
        orders={orders} //
        totalcount={totalcount}
      
        onPageChange={onPageChange}
        onPageLimit={onPageLimit}
      />

    </Page>
  );
});

export default ManageAds;
